import moment from "moment";

Vue.component('sales-dashboard', {
    props: ['client'],

    data () {
        return {
            filter: {
                from: moment().startOf('today').format("DD-MM-YYYY"),
                to: moment().endOf('today').format("DD-MM-YYYY"),
                type: '',
                client: ''
            },

            loading: true,

            sales: [],

            targetStatus: null,
            target: null,

            editSalesForm: $.extend(true, new Form({
                data: {
                    id: '',
                    assignee: '',
                    type: '',
                    value: '',
                    qty: '',
                    commission: '',
                    due_on: '',
                    note_box: ''
                },

                working: false,
            }), {}),

            columns: []
        };
    },

    mounted () {
        this.filter.client = this.client;

        this.getSales();
    },

    methods: {
        handleDateSelected (field, value) {
            this.editSalesForm.data[field] = value;
        },
        getSales () {
            this.loading = true;

            axios.get('/api/sales/dashboard', {
                params: {...this.filter}
            }).then((response) => {
                this.sales = response.data.sales;
                this.targetStatus = response.data.target_status;
                this.target = response.data.target;

                let dateStart = moment(this.filter.from, "DD-MM-YYYY");
                let dateEnd = moment(this.filter.to, "DD-MM-YYYY");
                let values = [];

                while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
                    values.push({
                        display: dateStart.format('MM/YYYY'),
                        column: dateStart.format('YYYY-MM')
                    });

                    dateStart.add(1,'month');
                }

                this.columns = values;   
            });
            this.loading = false;
        },

        downloadParameters () {
            let params = [
                'export_type=dashboard'
            ];

            for (let field in this.filter) {
                params.push(field + '=' + this.filter[field]);
            }

            return '?' + params.join('&');
        },

        getAdminsContent (admins) {
            let html = '';
            let percent = Number(100 / admins.length).toFixed(2);

            for (let admin of admins) {
                html += '<strong>'+ admin.first_name + ' ' + admin.last_name + '</strong>: ' + percent + '%<br>';
            }

            return html;
        },

        calculateRollingTotal(parameter) {
            let total = 0;

            for (let sale of this.sales) {
                if (sale[parameter] != undefined) {
                    total += sale[parameter];
                }
            }

            return total;
        },

        loadEdit (index) {
            let data = {...this.sales[index]};

            data.due_on = moment(data.due_on).format("DD-MM-YYYY");
            data.assignee = Number(data.user_id);
            data.commission_id = data.type;
            
            this.editSalesForm.data = data;
        },

        update () {
            Http.post('/api/sales/update', this.editSalesForm, {}).then((response) => {
                this.editSalesForm.resetAlert();

                this.getSales();

                $('#edit-sale').modal('hide');
            });
        },

        handleFilterDateSelected (field, value) {
            this.filter[field] = value;
        }
    },

    filters: {
        date (value) {
            return value != null ? moment(value).format("DD-MM-YYYY") : value;
        }
    },

    computed: {
        projectedTotal () {
            if (this.sales.length === 0) {
                return 0;
            }

            let count = 0;

            this.sales.map(sale => {
                count += Number(sale.total);
            });

            return count.toFixed(2);
        },

        projectedCommission () {
            if (this.sales.length === 0) {
                return 0;
            }

            let count = 0;

            this.sales.map(sale => {
                count += Number(sale.commission);
            });

            return count.toFixed(2);
        },

        projectedNcCommission () {
            if (this.sales.length === 0) {
                return 0;
            }

            let count = 0;

            this.sales.map(sale => {
                count += Number(sale.nc_commission);
            });

            return count.toFixed(2);
        },

        actualTotal () {
            if (this.sales.length === 0) {
                return 0;
            }

            let count = 0;

            this.sales.map(sale => {
                if (sale.status == 'sale') {
                    count += Number(sale.actual_total);
                }
            });

            return count.toFixed(2);
        },

        actualCommission () {
            if (this.sales.length === 0) {
                return 0;
            }

            let count = 0;

            this.sales.map(sale => {
                if (sale.status == 'sale') {
                    count += Number(sale.actual_commission);
                }
            });

            return count.toFixed(2);
        },

        actualNcCommission () {
            if (this.sales.length === 0) {
                return 0;
            }

            let count = 0;

            this.sales.map(sale => {
                if (sale.status == 'sale') {
                    count += Number(sale.actual_nc_commission);
                }
            });

            return count.toFixed(2);
        },
    },

    watch: {
        sales () {
            Vue.nextTick(() => {
                setTimeout(() => {
                    $('[data-toggle="popover"]').popover({
                        trigger: 'hover',
                        html: true
                    });
                });
            });
        }
    }
});